import React, { useEffect } from "react"
import SimpleBar from "simplebar-react"
import MetisMenu from "metismenujs"
import { Link, useHistory } from "react-router-dom"
// import { useTranslation } from "react-i18next"
import { sidebarLinks } from "./sidebarLinks"
import { useSelector } from "react-redux"
import { environment } from "../../../environment.ts";



export const SidebarContent = (props) => {

    const refDiv = React.createRef()
    // const { t } = useTranslation('common');
    const { location } = useHistory();
    const { me } = useSelector((state) => state.auth)

    const renderUserAvatar = (user) => {
        if (user) {
            return (
                <div className="px-3 py-4 d-flex justify-content-center align-items-center">
                    <div className="d-flex align-items-center mx-2">
                        {user?.image ? <img className="rounded-circle avatar-sm" src={user?.image} alt="" /> : null}
                    </div>
                    <div className="user-details text-white d-flex flex-column align-items-start mb-0">
                        <h4 className="text-white mb-0">{user?.firstName + ' ' + user?.lastName}</h4>
                        <h6 className="text-danger mb-1">{user?.role ? user?.role : ""}</h6>
                        <h6 className="text-success mb-0">{environment.reactAppDate ? environment.reactAppDate : ""}</h6>
                    </div>
                </div>
            )
        }
        return null;
    }

    const renderSidebarLinks = () => {
        return sidebarLinks.map((s, si) => (

            <li key={si}>
                {(s.label === 'Content' && (me.role !== 'Member'))
                || (s.label === 'Seminar List' && (me.role === 'Administrator' || me.role === 'Event Manager' || me.role === 'Event + Curricula Manager'))
                || (s.label === 'Settings' && (me.role === 'Administrator' || me.role === 'Event Manager' || me.role === 'Curricula Manager' || me.role === 'Event + Curricula Manager'))
                || (s.label === 'Community List' && (me.role === 'Administrator' || me.role === 'Community Manager'))
                || (s.label === 'Curricula Module' && (me.role === 'Administrator' || me.role === 'Curricula Manager' || me.role === 'Event + Curricula Manager'))
                || (s.label === 'Curriculum List' && (me.role === 'Administrator'  || me.role === 'Curricula Manager' || me.role === 'Event + Curricula Manager'))
                || (s.label === 'SHI-HR Module' && (me.role === 'Administrator'  || me.role === 'SHI HR'))
                || (s.label === 'Users' && (me.role === 'Administrator'))
                || (s.label === 'Activity' && (me.role === 'Administrator'))
                || (s.label === 'System Logs' && (me.role === 'Administrator'))
                || (s.label === 'Help') ? (
                <Link to={s.route}>
                    {s.icon ? <i className={s.icon} /> : null}
                    {s.badge ? <span className="badge rounded-pill bg-info float-end">
                        {s.badge}
                    </span> : null}
                    <span>{s.label}</span>
                    {s.subMenu ? (<ul className="sub-menu" ariaExpanded="false">
                        {s.subMenu.map((cs, csi) => <li key={csi}>
                            <Link>
                                <span>{cs.label}</span>
                            </Link>
                        </li>)}
                    </ul>) : null}
                </Link>
                ) : (null)}
            </li>

        ))
    }


    useEffect(() => {

        const scrollElement = item => {
            setTimeout(() => {
                if (refDiv.current !== null) {
                    if (item) {
                        const currentPosition = item.offsetTop
                        if (currentPosition > window.innerHeight) {
                            if (refDiv.current)
                                refDiv.current.getScrollElement().scrollTop =
                                    currentPosition - 300
                        }
                    }
                }
            }, 300)
        }

        const activateParentDropdown = item => {
            item.classList.add("active")
            const parent = item.parentElement
            const parent2El = parent.childNodes[1]
            if (parent2El && parent2El.id !== "side-menu") {
                parent2El.classList.add("mm-show")
            }
            if (parent) {
                parent.classList.add("mm-active")
                const parent2 = parent.parentElement
                if (parent2) {
                    parent2.classList.add("mm-show") // ul tag
                    const parent3 = parent2.parentElement // li tag
                    if (parent3) {
                        parent3.classList.add("mm-active") // li
                        parent3.childNodes[0].classList.add("mm-active") //a
                        const parent4 = parent3.parentElement // ul
                        if (parent4) {
                            parent4.classList.add("mm-show") // ul
                            const parent5 = parent4.parentElement
                            if (parent5) {
                                parent5.classList.add("mm-show") // li
                                parent5.childNodes[0].classList.add("mm-active") // a tag
                            }
                        }
                    }
                }
                scrollElement(item)
                return false
            }
            scrollElement(item)
            return false
        }
        const initMenu = () => {
            new MetisMenu("#side-menu")
            let matchingMenuItem = null
            const ul = document.getElementById("side-menu")
            const items = ul.getElementsByTagName("a")
            for (let i = 0; i < items.length; ++i) {
                if (location.pathname === items[i].pathname) {
                    matchingMenuItem = items[i]
                } else {
                    if (items[i]) {
                        items[i].classList.remove('active');
                        items[i].parentNode.classList.remove('mm-active');
                    }
                }
            }
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem)
            }
        }
        initMenu()
    }, [location.pathname, refDiv]);

    return (
        <React.Fragment>
            <SimpleBar style={{ maxHeight: "100%" }} ref={refDiv}>
                <div id="sidebar-menu">
                    <ul className="metismenu list-unstyled" id="side-menu">
                        {renderUserAvatar(me)}
                        {renderSidebarLinks()}
                    </ul>
                </div>
            </SimpleBar>
        </React.Fragment>
    )

}
